import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="auto-submit"
export default class extends Controller {
  static targets = ["form", "fileInput"]

  submit() {
    if (!this.hasFormTarget) return

    if (this.hasFileInputTarget && this.fileInputTarget.files && this.fileInputTarget.files.length === 0) {
      return
    }

    if (this.formTarget.requestSubmit) {
      this.formTarget.requestSubmit()
    } else {
      this.formTarget.submit()
    }
  }
}
